import {IWizardSavedState} from './wizardSavedState';

export interface INavigationContext {
    wizardSavedState: IWizardSavedState;
}

export class NavigationContext implements INavigationContext {
    public wizardSavedState: IWizardSavedState;
}